import { FC } from 'react'
import { Navigate } from 'react-router'
import { NamespacedPageProps } from '../../../lib/entities'
import { LoadingView } from '../../molecules'
import { isUserInvited } from '../../../lib/utils'

interface ActiveUserWalledPageProps extends NamespacedPageProps {
    Page: FC<NamespacedPageProps>
}

export const ActiveUserWalledPage: FC<ActiveUserWalledPageProps> = ({
    Page,
    ...props
}) => {
    if (props.loading) return <LoadingView />
    if (!props.user || !props.organization) return null
    if (isUserInvited(props.user))
        return <Navigate replace to="/setup/profile" />
    return <Page {...props} />
}
